// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const catalogEs = {
  "controls": {
    "boot": "Arrancar",
    "reset": "Reiniciar",
    "copyScreen": "Copiar Pantalla",
    "copyText": "Copiar texto",
    "pasteText": "Pegar Texto",
    "saveState": "Guardar Estado",
    "restoreState": "Restaurar Estado",
    "toggleSound": "Alternar Sonido",
    "settings": "Configuración",
    "debugPanel": "Panel de Depuración",
    "infoPanel": "Panel de información",
    "reportIssue": "Reportar un problema",
    "privacyPolicy": "Política de privacidad"
  },
  "config": {
    "speed": "Velocidad de emulación",
    "display": "Configuración de Pantalla",
    "theme": "Tema",
    "openRetroControlPanel": "Panel de control",
    "resetSettings": "Restablecer Configuración",
    "capsLock": "Bloqueo de Mayúsculas",
    "useOpenApple": "Usar la tecla {{modKey}} para Open Apple",
    "useShortcuts": "Usar la tecla {{modKey}} para atajos de teclado",
    "useArrowKeys": "Usar Teclas de Flecha como Joystick",
    "scanlines": "Líneas de Escaneado CRT",
    "ghosting": "Persistencia de Fósforo",
    "crtDistortion": "Distorsión CRT",
    "joystick": "Configuración de joystick"
  },
  "machine": {
    "slotConfigurator": "Ranuras de expansión"
  },
  "speed": {
    "snail": "A paso de tortuga (0.1 MHz)",
    "slow": "Velocidad baja (0.5 MHz)",
    "normal": "Velocidad normal (1 MHz)",
    "fast": "Velocidad rápida (4 MHz)",
    "warp": "Velocidad absurda"
  },
  "colors": {
    "nofringe": "Color (sin flecos)",
    "green": "Verde",
    "amber": "Ámbar",
    "white": "Blanco y Negro",
    "inverse": "Blanco y Negro (inverso)"
  },
  "themes": {
    "classic": "Clásico",
    "dark": "Oscuro",
    "minimal": "Minimalista"
  },
  "debug": {
    "helpPanel": "Mostrar panel de ayuda",
    "debugPanel": "Mostrar panel de depuración",
    "expectinPanel": "Mostrar panel Apple exPectin",
    "helpTab": "Ayuda",
    "debugTab": "Depuración",
    "breakpoints": "Puntos de Interrupción",
    "memory": "Memoria",
    "stack": "Pila",
    "state": "Estado de CPU",
    "registers": "Registros",
    "flags": "Banderas",
    "step": "Paso",
    "stepOver": "Paso Sobre",
    "stepInto": "Paso Dentro",
    "stepOut": "Paso Fuera",
    "resume": "Reanudar",
    "pause": "Pausar",
    "loadSymbolTable": "Cargar tabla de símbolos",
    "disassembly": "Desensamblado"
  },
  "tour": {
    "welcome": "¡Bienvenido al emulador Apple2TS!",
    "clickNext": "Para saber más, presiona el botón Siguiente.",
    "bootButton": "Haz clic aquí para iniciar el emulador.",
    "resetButton": "Haz clic aquí para reiniciar el Apple II y reiniciar o entrar a BASIC.",
    "diskImages": "Elige una de las imágenes de disco instaladas.",
    "floppyDisks": "O haz clic en uno de los iconos de disquete para cargar una imagen de disco.",
    "saveRestore": "Puedes guardar y restaurar el estado completo del emulador usando estos botones.",
    "themeButton": "Haz clic aquí para cambiar el tema de la interfaz del emulador.",
    "endTour": "Has llegado al final del recorrido. Haz clic en el botón de recorrido del globo para probar uno de los otros recorridos, o presiona Finalizar para comenzar a usar el emulador.",
    "tourSelectorHint": "Haz clic en el botón de recorrido del globo para probar uno de los otros recorridos, o presiona Finalizar para comenzar a usar el emulador.",
    "settingsWelcome": "Apple2TS tiene un conjunto completo de controles tanto para el emulador como para el Apple II. Para saber más, presiona el botón Siguiente.",
    "mainControls": "Aquí, puedes arrancar y reiniciar el Apple II, restaurar y guardar el estado, copiar la pantalla, o pegar texto en el emulador.",
    "snapshot": "En cualquier momento, puedes tomar una captura del estado actual del emulador, luego retroceder a un estado anterior, o avanzar rápidamente de nuevo. También puedes guardar el estado del emulador con todas las capturas actuales.",
    "pauseButton": "Puedes pausar el emulador en cualquier momento, congelando el procesador 6502. Esto es útil para pausar la acción en un juego, o entrar al depurador.",
    "debugButton": "Haz clic en el insecto para entrar al modo de depuración, donde puedes ver el estado interno del procesador 6502. Haz clic de nuevo para volver al modo normal.",
    "configButtons": "La fila inferior de botones controla el estado del Apple II, comenzando con la velocidad de emulación, el color de la pantalla y la desactivación del sonido.",
    "keyboardButtons": "Si la tecla de bloqueo de mayúsculas está activada, entonces todos los caracteres escritos son MAYÚSCULAS.",
    "altArrowKeys": "La siguiente tecla determina si la tecla {{modKey}} se usa para atajos de teclado o la tecla Open Apple del Apple II. La tecla final determina si las teclas de flecha pueden usarse como el joystick del Apple II.",
    "clearCookies": "Apple2TS automáticamente guarda la configuración actual del emulador como cookies del navegador. Presiona este botón para restablecer esta configuración y eliminar las cookies.",
    "debugWelcome": "Apple2TS tiene un rico conjunto de herramientas para analizar y depurar código ensamblador 6502. Para saber más, presiona el botón Siguiente.",
    "debugIcon": "Haz clic en el icono del Insecto en las pestañas de Información para ver el panel de Depuración.",
    "debugPause": "Presiona el botón Pausar para pausar o reanudar la ejecución del emulador.",
    "debugControls": "Ahora que hemos pausado, podemos avanzar paso a paso a través del código desensamblado usando los botones Paso Sobre, Dentro, y Fuera. También podemos saltar rápidamente a la dirección actual del Contador de Programa (PC).",
    "debugDisassembly": "Aquí vemos el código desensamblado, con las direcciones hexadecimales, la instrucción de tres letras, y cualquier valor o dirección. Si mueves el ratón sobre un valor verde, aparecerá una información sobre herramientas con el valor actual. Hacer clic en una dirección azul se desplazará a esa ubicación. También puedes hacer clic en el margen izquierdo para añadir o eliminar puntos de interrupción.",
    "debugInfo": "En el medio tenemos el Volcado de Pila y un Mapa de Memoria. El Mapa de Memoria se actualiza en tiempo real y te muestra qué bancos de memoria están actualmente activos.",
    "debugMemory": "La última sección muestra la memoria del Apple II. Puedes usar la lista desplegable para examinar diferentes porciones de memoria. Si cambias a una de las páginas HGR, obtendrás una vista ampliada de la pantalla de alta resolución, vinculada a las ubicaciones de memoria. También puedes buscar valores hexadecimales o cadenas ASCII, y guardar la memoria en un archivo.",
    "back": "Atrás",
    "close": "Cerrar",
    "last": "Finalizar",
    "next": "Siguiente",
    "nextLabelWithProgress": "Siguiente (Paso {step} de {steps})",
    "skip": "Cerrar",
    "guidedTour": "Tour Guiado",
    "mainLabel": "Tour Guiado: Principal",
    "settingsLabel": "Tour Guiado: Ajustes",
    "debugLabel": "Tour Guiado: Depuración"
  },
  "disk": {
    "drive1": "Unidad 1",
    "drive2": "Unidad 2",
    "hardDisk": "Disco Duro",
    "eject": "Expulsar Disco",
    "insert": "Insertar Disco",
    "writeProtected": "Protegido contra Escritura",
    "readWrite": "Lectura/Escritura",
    "empty": "Vacío",
    "loading": "Cargando...",
    "selectDisk": "Seleccionar Imagen de Disco",
    "browse": "Explorar",
    "newReleases": "Nuevos Lanzamientos",
    "writeProtectDisk": "Protección contra Escritura de Disco",
    "saveDiskToDevice": "Guardar Disco",
    "saveDiskTo": "Guardar Disco en",
    "saveDiskToMenu": "Guardar Disco en >",
    "addToFavorites": "Añadir a Favoritos",
    "downloadDisk": "Descargar Disco",
    "downloadWoz": "Descargar imagen de disco WOZ",
    "downloadAndEjectDisk": "Descargar y Expulsar Disco",
    "ejectDisk": "Expulsar Disco",
    "ejectAllDisks": "Expulsar todos los discos",
    "saveDiskToOneDrive": "Guardar Disco en OneDrive",
    "saveDiskToGoogleDrive": "Guardar Disco en Google Drive",
    "loadDisk": "Cargar disco",
    "loadAdditionalDisks": "Cargar disco adicional...",
    "loadDiskFrom": "Cargar Disco desde",
    "loadDiskFromMenu": "Cargar Disco desde >",
    "loadDiskFromDevice": "Cargar Disco",
    "loadDiskFromDeviceReadOnly": "Cargar Disco desde Dispositivo (Solo Lectura)",
    "loadDiskFromDeviceReadWrite": "Cargar Disco desde Dispositivo (Lectura/Escritura)",
    "loadDiskFromInternetArchive": "Cargar Disco desde Internet Archive",
    "loadDiskFromOneDrive": "Cargar Disco desde OneDrive",
    "loadDiskFromGoogleDrive": "Cargar Disco desde Google Drive",
    "insertBlankDisk": "Insertar disco en blanco",
    "syncEveryMinute": "Sincronizar Cada Minuto",
    "syncEvery5Minutes": "Sincronizar Cada 5 Minutos",
    "pauseSyncing": "Pausar Sincronización",
    "syncNow": "Sincronizar Ahora",
    "modified": "modificado",
    "synced": "sincronizado",
    "diskImage": "Imagen de Disco",
    "diskDrivesAndDevices": "unidades de disco y dispositivos",
    "syncedAt": "Sincronizado {{date}}",
    "clickToLoadDiskImage": "Haga clic para cargar la(s) imagen(es) del disco",
    "clickToRemoveFromDiskCollection": "Haga clic para eliminar de la colección de discos",
    "clickToAddToDiskCollection": "Haga clic para agregar a la colección de discos",
    "byCreator": "por {{creator}}",
    "clickToViewDetails": "Haga clic para ver detalles",
    "standbyDisks": "Discos en espera (Haga clic para cambiar de disco)"
  },
  "help": {
    "title": "Apple2TS",
    "subtitle": "Emulador de Apple IIe en TypeScript",
    "credit": "(c) {{year}} Chris Torrence y los colaboradores de Apple2TS",
    "keyboardShortcuts": "Atajos de Teclado",
    "shortcutsUnavailable": "Los atajos del emulador con {{keyMod}} no están disponibles mientras esa tecla esté asignada a Open Apple. Ctrl+0 a Ctrl+5 siguen seleccionando la velocidad de emulación.",
    "diskImages": "Imágenes de disco:",
    "diskContainers": "Archivos comprimidos:",
    "multiDiskNotice": "Intercambio de múltiples discos: Haga clic en la insignia multidisco para abrir el menú de intercambio rápido. Los archivos multidisco (.zip, .7z, .gz) se cargan automáticamente en la lista de intercambio.",
    "urlParameters": "Parámetros de URL Opcionales",
    "examples": "Ejemplos",
    "mobileInstructions": "Plataformas móviles:",
    "tapScreen": "Toca la pantalla para mostrar el teclado.",
    "arrowKeys": "Presiona las teclas de flecha, esc, o tab para enviar esas teclas al emulador.",
    "ctrlKey": "Para enviar un carácter de control, presiona el botón ctrl una vez. Luego toca la pantalla para mostrar el teclado y presiona la tecla deseada. El botón ctrl se liberará automáticamente.",
    "ctrlLock": "Para enviar múltiples caracteres de control, presiona el botón ctrl dos veces para bloquearlo (indicado por un punto verde). Luego toca la pantalla para mostrar el teclado y presiona las teclas deseadas. Presiona el botón ctrl de nuevo para liberarlo.",
    "appleKeys": "Las teclas open apple y closed apple se comportan igual que la tecla ctrl.",
    "openAppleKey": "Open Apple: presiona Alt/Opción Izq",
    "closedAppleKey": "Closed Apple: presiona Alt/Opción Der",
    "joystickKeys": "Teclas Joystick: Teclado Num 8/2/4/6 (7/9/1/3), 0/5, ./Enter",
    "onScreenKeyboard": "Para el teclado en pantalla, para usar CTRL o ESC:\npulsar una vez para activar y luego la tecla deseada.",
    "urlParametersBody": "Para los parámetros de URL opcionales, añádalos a la URL después de un signo de interrogación (?) y separe varios parámetros con un ampersand (&). Use # para especificar la imagen de disco. Consulte el diálogo del Generador de enlaces para ver ejemplos.",
    "exampleLinks": {
      "totalReplayDebugging": "Total Replay con depuración",
      "totalReplayChoplifter": "Total Replay, cargar Choplifter, modo incrustado",
      "a2Desktop": "A2DeskTop 2MG con velocidad rápida y color",
      "embeddedBasic": "Programa Applesoft BASIC Incrustado",
      "binaryHexAddress": "Archivo Binario con Dirección Hexadecimal"
    },
    "links": "Enlaces",
    "resourceLinks": {
      "desktopApp": "Aplicación de escritorio Apple2TS",
      "corsProxy": "Proxy CORS de Corsfix",
      "silverCjkFont": "Silver CJK Pixel Font"
    }
  },
  "messages": {
    "loading": "Cargando...",
    "success": "Éxito",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "on": "encendido",
    "off": "apagado",
    "confirmTheme": "¿Recargar el emulador y aplicar este tema ahora?",
    "confirmReset": "¿Restablecer toda la configuración a valores predeterminados?",
    "fileNotFound": "Archivo no encontrado",
    "invalidFile": "Formato de archivo inválido",
    "diskInserted": "Disco insertado",
    "diskEjected": "Disco expulsado"
  },
  "keyboard": {
    "capsLock": "Bloqueo de Mayúsculas",
    "space": "Espacio",
    "backspace": "Retroceso",
    "delete": "Eliminar"
  },
  "audio": {
    "speaker": "Altavoz",
    "midi": "MIDI",
    "configuration": "Configuración de audio",
    "volume": "Volumen",
    "mute": "Silenciar",
    "waveform": "Forma de Onda"
  },
  "print": {
    "printer": "Impresora",
    "print": "Imprimir",
    "clear": "Limpiar",
    "save": "Guardar Salida",
    "dumpScreen": "Volcar pantalla actual a la impresora",
    "dumpScreenInverse": "Volcar pantalla actual (Inverso)",
    "sendToPrinter": "Enviar a la impresora",
    "tearOff": "Arrancar página y restablecer",
    "printedPage": "Página impresa",
    "printerConfig": "Configuración de la impresora",
    "pageLength": "Longitud de página",
    "pageLengthLetter": "11 pulgadas (Carta)",
    "pageLengthA4": "11,7 pulgadas (A4)",
    "pageLengthTwelve": "12 pulgadas"
  },
  "device": {
    "machineConfiguration": "Configuración de Máquina",
    "midiDeviceSelect": "Selección de Dispositivo MIDI",
    "serialPortSelect": "Selección de Puerto Serie",
    "mockingboardWaveform": "Forma de Onda Mockingboard"
  },
  "collection": {
    "showApple2TSCollection": "Mostrar Colección Apple2TS",
    "showNewReleases": "Mostrar nuevos lanzamientos",
    "showFavorites": "Mostrar favoritos",
    "chooseDiskImage": "Elegir imagen de disco",
    "diskCollection": "Colección de discos",
    "clickToShowDetails": "Haz clic para mostrar detalles de",
    "clickToLoadDisk": "Haz clic para cargar disco",
    "diskIsNewRelease": "El disco es un nuevo lanzamiento",
    "diskIsApple2TSCollection": "El disco es parte de la colección Apple2TS",
    "diskIsInternetArchive": "El disco es parte del Internet Archive",
    "clickToRemoveFromCollection": "Haz clic para quitar de la colección de discos",
    "clickToAddToCollection": "Haz clic para añadir a la colección de discos",
    "diskIsSyncedVia": "El disco se sincroniza vía",
    "loadDiskIntoDrive": "Cargar Disco en Unidad",
    "exportDisksToHdv": "Exportar discos a HDV",
    "export": "Exportar",
    "clickToRemoveFromSelected": "Clic para quitar de los discos seleccionados",
    "clickToAddToSelected": "Clic para añadir a los discos seleccionados",
    "reportExportIssue": "Reportar un problema de exportación"
  },
  "debugControls": {
    "goBackInTime": "Retroceder en el Tiempo",
    "takeSnapshot": "Tomar Captura",
    "goForwardInTime": "Avanzar en el Tiempo",
    "saveStateWithSnapshots": "Guardar Estado con Capturas",
    "resume": "Reanudar",
    "pause": "Pausar",
    "trace": "Rastreo",
    "tracing": "Rastreando",
    "downloadTraceLog": "Descargar diario de rastreo"
  },
  "fullscreen": {
    "fullScreen": "Pantalla Completa"
  },
  "internetArchive": {
    "searchPlaceholder": "Escribe el nombre de un software o haz clic en una de las categorías de arriba",
    "go": "IR"
  },
  "basic": {
    "newProgram": "Nuevo programa",
    "runFromBeginning": "Ejecutar desde el principio",
    "break": "Interrumpir",
    "continueRunning": "Continuar ejecutando",
    "stepProgram": "Paso a paso del programa",
    "resumeOutput": "Reanudar salida",
    "freezeOutput": "Congelar salida",
    "importProgram": "Importar programa...",
    "exportProgram": "Exportar programa...",
    "renumberProgram": "Renumerar programa",
    "rebuildProgram": "Reconstruir programa desde la memoria",
    "displaySettings": "Configuración de pantalla",
    "autoLineNumbering": "Numeración automática de líneas",
    "capitalizeKeywords": "Poner palabras clave en mayúsculas",
    "rebuildWarning": "Esto reemplazará el programa actual con una versión reconstruida desde la memoria del Apple II. Perderá cualquier cambio no guardado. ¿Está seguro?",
    "value": "Valor"
  },
  "expectin": {
    "runScript": "Ejecutar script",
    "stopScript": "Detener script"
  },
  "saveDisassembly": {
    "title": "Guardar desensamblado",
    "startAddress": "Dirección de inicio $",
    "endAddress": "Dirección final $",
    "includeLabels": "Incluir etiquetas de símbolos",
    "separatorLines": "Líneas separadoras después de JMP, RTS"
  },
  "gamepad": {
    "useArrowKeys": "Teclas de flecha como joystick",
    "siriusJoyport": "Modo Sirius Joyport"
  },
  "traceSettings": {
    "title": "Ajustes de traza",
    "settings": "Ajustes"
  },
  "linkBuilder": {
    "startupOptionsTab": "Opciones de inicio",
    "speedNames": {
      "snail": "Tortuga",
      "warp": "Absurda"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192"
    },
    "slots": {
      "configure": "Configurar tarjetas de ranura",
      "slot": "Ranura {{slot}}:",
      "cardNone": "Ninguna (vacía)"
    },
    "additionalDiskDrives": "Unidades de disco adicionales",
    "slot6Drive1": "Ranura 6 Unidad 1 (Disquete 1)",
    "slot6Drive2": "Ranura 6 Unidad 2 (Disquete 2)",
    "slot7Drive1": "Ranura 7 Unidad 1 (Disco duro 1)",
    "slot7Drive2": "Ranura 7 Unidad 2 (Disco duro 2)",
    "slot2Drive1": "Ranura 2 Unidad 1 (VERA SD)",
    "slot4Drive1": "Ranura 4 Unidad 1 (VERA SD)",
    "addAdditionalDisk": "Agregar disco adicional para intercambiar",
    "removeDisk": "Quitar este disco",
    "addAnotherDisk": "Agregar otro disco",
    "diskPlaceholder": "Nombre de archivo del disco {num} (p. ej. sideB.woz|Disco de escenario)"
  },
  "startup": {
    "welcome": "Bienvenido a Apple2TS",
    "subtitle": "Emulador TypeScript de Apple II",
    "copyright": "(c) {{year}} C.Torrence y colaboradores",
    "diskCollections": "Clic en Colección de discos\npara cargar un juego integrado."
  },
  "retroControl": {
    "machine": "Máquina",
    "fullscreen": "Pantalla completa",
    "diskCollection": "Discos",
    "diskDrives": "Unidades de disco",
    "display": "Pantalla",
    "monitorMode": "Modo de monitor",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "Sonido",
    "options": "Opciones",
    "skin": "Apariencia",
    "personalization": "Personalización",
    "text": "Texto",
    "background": "Fondo",
    "border": "Borde",
    "iigsColor": {
      "black": "Negro",
      "red": "Rojo",
      "darkBlue": "Azul oscuro",
      "purple": "Morado",
      "darkGreen": "Verde oscuro",
      "darkGray": "Gris oscuro",
      "mediumBlue": "Azul medio",
      "lightBlue": "Azul claro",
      "brown": "Marrón",
      "orange": "Naranja",
      "lightGray": "Gris claro",
      "pink": "Rosa",
      "lightGreen": "Verde claro",
      "yellow": "Amarillo",
      "aquamarine": "Aguamarina",
      "white": "Blanco"
    },
    "keyboard": "Teclado",
    "joystick": "Joystick",
    "slots": "Ranuras",
    "devices": "Dispositivos",
    "printerPort": "Puerto de impresora",
    "modemPort": "Puerto de módem",
    "quit": "Salir",
    "apple2tsCollection": "Colección Apple2TS",
    "newReleases": "Novedades",
    "favorites": "Favoritos",
    "exportDisksToHdv": "Exportar discos a HDV",
    "noDiskDrivesAvailable": "No hay unidades de disco disponibles",
    "select": "Seleccionar",
    "open": "Abrir",
    "load": "Cargar",
    "go": "Ir",
    "save": "Guardar",
    "clipboard": "Portapapeles",
    "cancelEsc": "Cancelar:Esc",
    "color": "Color",
    "systemSpeed": "Velocidad del sistema",
    "other": "Otro",
    "timeMachine": "Instantáneas",
    "ports": "Puertos",
    "language": "Idioma",
    "retroTheme": "Retro",
    "lowercaseInput": "Entrada en minúsculas",
    "openAppleKey": "Tecla Open Apple",
    "sortOrder": "Ordenar",
    "card": {
      "empty": "Vacío",
      "mockingboard": "Mockingboard"
    }
  }
}
